import { useNavigate } from '@tanstack/react-router'
import { Eye, X } from 'lucide-react'
import { exitViewAs, useViewAs } from '@/lib/viewAs'

// The height AppShell reserves for the bar, so full-height pages can subtract it.
export const VIEW_AS_BAR_HEIGHT = '2.25rem'

// Solid amber across the top of every page: the lens follows staff from page to page, so it must be impossible to
// forget they are in it.
export function ViewAsBar() {
  const viewAs = useViewAs()
  const navigate = useNavigate()
  if (!viewAs) return null

  const exit = () => {
    exitViewAs()
    navigate({ to: '/admin/view-as' as never })
  }

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex shrink-0 items-center justify-between gap-4 bg-[var(--etn-amber-500)] px-7 text-etn-control text-etn-navbar"
      style={{ height: VIEW_AS_BAR_HEIGHT }}
    >
      <span className="flex min-w-0 items-center gap-2">
        <Eye className="h-4 w-4 shrink-0" aria-hidden />
        <span className="truncate">
          Viewing as <strong className="font-semibold">{viewAs.name || viewAs.email}</strong>
          {viewAs.name && viewAs.email && <span className="opacity-75"> ({viewAs.email})</span>}
          {viewAs.companyName && <> at <strong className="font-semibold">{viewAs.companyName}</strong></>}
          <span className="opacity-75">. Read-only.</span>
        </span>
      </span>
      <button
        type="button"
        onClick={exit}
        className="inline-flex shrink-0 items-center gap-1.5 rounded-etn-pill bg-etn-navbar px-3 py-1 text-etn-control-sm font-semibold text-white hover:bg-etn-navbar/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-etn-navbar"
      >
        <X className="h-3.5 w-3.5" aria-hidden />
        Exit
      </button>
    </div>
  )
}
